import { useState } from 'react';

import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from "react-redux";
import {closeShortMSG} from '../service/actionServices'
export default function ShortMSG() {

  const snackBarData = useSelector((state)=>state.snackBar)
  const dispatch = useDispatch();

  const [state,setState] = useState({
    vertical: 'bottom',
    horizontal: 'right',
  })
  const { vertical, horizontal,  } = state;


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(closeShortMSG());
  };

  const action = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <div>
      <Snackbar
        open={snackBarData&&snackBarData.stage&&snackBarData.stage}
        autoHideDuration={4000}
        onClose={handleClose}
        message={snackBarData&&snackBarData.message&&snackBarData.message}
        action={action}
        anchorOrigin={{ vertical, horizontal }}
      />
    </div>
  );
}
